import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Tip } from '../models/tip.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiConfigService } from './api-config.service';
import { CsrfService } from './csrf.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TipService {

  constructor(private http: HttpClient, private apiConfigService: ApiConfigService, private csrfService: CsrfService) { }

  getRecentTips(): Observable<Tip[]> {
    return this.http.get<Tip[]>(this.apiConfigService.getApiUrl('get_recent_tips'));
  }

  submitTip(tip: any): Observable<any> {
    return this.csrfService.getCsrfToken().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'X-CSRF-Token': token
        });
        return this.http.post(this.apiConfigService.getApiUrl('submit_tip'), tip, { headers });
      })
    );
  }
}